import define1 from "./e93997d5089d7165@2303.js";
import define2 from "./1af09d6cfe099fd4@5199.js";
import define3 from "./a33468b95d0b15b0@808.js";
import define4 from "./266e717755b1d175@112.js";
import define5 from "./f45aab9de8312df2@403.js";
import define6 from "./20f78e399de08ef0@857.js";

function _1(md){return(
md`# BUSTED analysis result visualization`
)}

function _results_file(params,localFileInput){return(
params.get ("url") ? localFileInput({accept: [".json",".gz"], value : params.get ("url"), disable: true}) : localFileInput({accept: [".json",".gz"]})
)}

function _intro(md,results_json,floatFormat,srv_rate_classes,srv_hmm,_,mh_rates,contributing_sites,has_error_sink){return(
md`<span style = 'font-size: 110%; color: firebrick;'>Based on the likelihood ratio test, there **is ${results_json["test results"]["p-value"]>0.05 ? "no" : ""}** evidence of _episodic diversifying selection_ in this dataset (<tt>p=${floatFormat(results_json["test results"]["p-value"])}</tt>).</span> <br>BUSTED analysis (v<tt>${results_json.analysis.version}</tt>) was performed on the alignment from <tt>${results_json.input["file name"]}</tt> using HyPhy v<tt>${results_json.runtime}</tt>. This analysis ** ${srv_rate_classes > 0 ? "included" : "did not include"}** site-to-site synonymous rate variation${srv_hmm?" with linear autocorrelation (HMM)" : ""}. ${_.isUndefined (mh_rates['DH']) ? "" : (_.isUndefined (mh_rates['TH']) ? "Double nucleotide substitutions were included in the model." : "Double and triple nucleotide substitutions were included in the model.")}${+results_json.analysis.version < 4.0 ? "<small><b>Some of the visualizations are not available for BUSTED analyses before v4.0</b>" : ""} ${contributing_sites && contributing_sites.length == 1? "\n><small style = 'color:firebrick'><i class='icon-fire icons'></i>Most of the statistical signal for episodic diversifying selection in this alignment is derived from a single codon site (**codon " + (1+contributing_sites[0])  + "**). This could be a sign of possible data quality issues, or outsized influence of a few substitutions, especially if they involve replacing multiple nucleotides along a short branch. You may want to examine the alignment at this site using BUSTED visualization tools, performing model-averaged inference, or rerunning the alignment with data at that site masked to confirm robustness of the result</small>" : ""} ${+results_json.analysis.version >= 4.5 && has_error_sink ? "<br><small style = 'color:darkgreen'>This analysis was run with the error sink category enabled</small>" : ""} 
`
)}

function _4(md,has_error_sink_nt,proportionFormat,get_error_sink_rate,has_background){return(
md`${has_error_sink_nt? "<details><summary style='background-color: 0xCCC; color: firebrick; font-size: 0.75em;'>Possible alignment errors detected</summary><span style='background-color: 0xCCC; color: darkorange; font-size: 0.75em;'>A " +proportionFormat (get_error_sink_rate ("Test")["proportion"]) + " fraction of the alignment (test branches" + (has_background ? ", and " + proportionFormat (get_error_sink_rate ("Background")["proportion"]) + " of background branches)"  : ")" ) + " was placed in the <b>error sink</b> rate class, meaning that misalignment or other data quality issues may be present. You may use exploratory plots and other components on this page to further explore this.</span></details>" : ""}`
)}

function _citation(md,results_json){return(
md`<small>**Suggested citation**: <tt><small>${results_json.analysis["citation"]}</small></tt></small>`
)}

function _pv(Inputs,html){return(
Inputs.text({label: html`<b>Evidence ratio threshold</b>`, value: "10", submit: "Update"})
)}

function _summary_table(html,results_json,tested_branch_count,omega_rate_classes,srv_rate_classes,srv_hmm,floatFmt,_,pv,mh_rates,bsPositiveSelection,contributing_sites,sub_fractions,percentageFormat){return(
html`<table style = 'font-size: 11px; width: 100%;'>
<tr>
<td style = 'width: 33%;'>
  <div class="stati asbestos left ">
      <i class="icon-options-vertical icons"></i>
      <div>
      <b>${results_json.input["number of sequences"]}</b>
      <span>sequences in the alignment</span>
      </div> 
  </div>
</td>
<td>
  <div class="stati asbestos left ">
  <i class="icon-options icons"></i>
  <div>
  <b>${results_json.input["number of sites"]}</b>
  <span>codon sites in the alignment</span>
  </div> 
  </div>
</td>
<td>
  <div class="stati asbestos left ">
  <i class="icon-arrow-up icons"></i>
  <div>
  <b>${results_json.input["partition count"]}</b>
  <span>partitions</span>
  </div> 
  </div>
</td>
</tr>
<tr>
<td>
  <div class="stati midnight_blue left ">
  <i class="icon-share icons"></i>
  <div>
  <b>${tested_branch_count}</b>
  <span>median branches/partition used for testing</span>
  </div> 
  </div>
</td>
<td style = 'width: 33%;'>
  <div class="stati midnight_blue left ">
  <i class="icon-grid icons"></i>
  <div>
  <b>${omega_rate_classes} classes</b>
  <span>non-synonymous rate variation</span>
  </div> 
  </div>
</td>
<td style = 'width: 33%;'>
  <div class="stati midnight_blue left ">
  <i class="icon-layers icons"></i>
  <div>
  <b>${srv_rate_classes ? "" + srv_rate_classes + " classes" : "None"}${srv_hmm ? " HMM" : ""} </b>
  <span>synonymous rate variation</span>
  </div> 
  </div>
</td>
</tr>
<tr>
<td style = 'width: 33%;'>
  <div class="stati amethyst left ">
  <i class="icon-plus icons"></i>
  <div>
  <b>${floatFmt(results_json["test results"]["p-value"])}</b>
  <span>p-value for episodic diversifying selection</span>
  </div> 
  </div>
</td>
<td>
  <div class="stati  amethyst left ">
  <i class="icon-energy icons"></i>
  <div>
  <b>${results_json["Evidence Ratios"]["constrained"] ? _.filter (results_json["Evidence Ratios"]["constrained"][0], (d)=>d >= pv).length : 0}</b>
  <span>Sites with ER≥${pv} for positive selection</span>
  </div> 
  </div>
</td>
<td>
  <div class="stati  amethyst left ">
  <i class="icon-target icons"></i>
  <div>
  <b>${!_.isUndefined(mh_rates['DH']) ? floatFmt (mh_rates['DH']) : "N/A"}:${!_.isUndefined(mh_rates['TH']) ? floatFmt (mh_rates['TH']) : "N/A"}</b>
  <span>Multiple hit rates (2H:3H)</span>
  </div> 
  </div>
</td>
</tr>
<tr>
<td style = 'width: 33%;'>
  <div class="stati nephritis left ">
  <i class="icon-bulb icons"></i>
  <div>
  <b>${results_json["Evidence Ratios"]["constrained"] ?_.filter (bsPositiveSelection, d=>d.ER >= 100).length : "N/A"}</b>
  <span>(branch, site) pairs with EBF ≥ 100</span>
  </div> 
  </div>
</td>
<td>
  <div class="stati  nephritis left ">
  <i class="icon-tag icons"></i>
  <div>
  <b>${contributing_sites ? contributing_sites.length : "N/A"}</b>
  <span>Sites contributing most signal to EDS detection</span>
  </div> 
  </div>
</td>
<td>
  <div class="stati  amethyst left ">
  <i class="icon-target icons"></i>
  <div>
  <b>${!_.isUndefined(sub_fractions[0]) ? percentageFormat (sub_fractions[0]) : "N/A"}:${!_.isUndefined(sub_fractions[1]) ? percentageFormat (sub_fractions[1]) : "N/A"}</b>
  <span>Expected fractions of MH subs (2H:3H)</span>
  </div> 
  </div>
</td>
</tr>
</tr>
</table>
`
)}

function _alignmentHeader(md){return(
md`#### Alignment-wide results`
)}

function _rate_table(Inputs,distributionTable,html,d3,_,floatFormat,proportionFormat,distMean,distVar,renderDiscreteDistribution,srv_rate_classes,has_background){return(
Inputs.table (distributionTable, {
  header : {'LogL' : "Log (L)", "AICc" : "AIC-c", "p" : html`<abbr title="Number of estimated parameters">Params.</abbr`, "dist" : "Rate distribution", "plot" : "Rate plot"},
  format : {
    'LogL' : d3.format ("2g"),
    'AICc' : d3.format ("2g"),
    'dist' : (d)=>{
        return html`<b>${d[0] + " " + d[2]}</b><br><tt>
            ${_.map (d[1], (c,i)=> floatFormat(c.value) + " (" + proportionFormat (c.weight) + ") ")}
            <br>Mean = <b>${floatFormat (distMean (d[1]))}</b>, CoV = <b>${floatFormat (Math.sqrt (distVar (d[1]))/distMean (d[1]))}</b></tt>`},
     'plot' : (d)=>renderDiscreteDistribution (d[1],{"height" : 50, "width" : 150, "scale" : "sqrt", "ref" : d[0].length == 0 ? [null] : [1]})
  },
  layout: "auto",
  height: 150 + (srv_rate_classes ? 120 : 0) + (has_background ? 120 :0)
})
)}

function _distComparisonPlot(rate_table,renderTwoDiscreteDistributions,md){return(
rate_table.length == 2 ? renderTwoDiscreteDistributions (rate_table[0].dist[1],rate_table[1].dist[1],{"label" : {"chart" : rate_table[0].plot[0], "series" : [rate_table[0].dist[3],rate_table[1].dist[3]]}, "width" : 700, "height" : 120, "scale" : "sqrt", "margin" : {top: 5, right: 250, bottom: 30, left: 20}}) : md`<small>Select exactly two distributions to plot a side-by-side comparison</small>`
)}

function _plot_type(Inputs,_,plot_options,results_json,html){return(
Inputs.select(_.map (_.filter (plot_options, (d)=>d[1](results_json)), d=>d[0]),{label: html`<b>Plot type</b>`})
)}

function _fig1_controls(plot_extras,plot_type,Inputs){return(
plot_extras[plot_type] || Inputs.text({label: "Plot options", value: "None", disabled: true})
)}

function _fig1caption(md,plot_type,plot_legends){return(
md`**Figure 1**. ${plot_type ? plot_legends[plot_type] : "No plotting options available"}`
)}

function _figure1(plot_type,vegalite,plot_specs,md){return(
plot_type ? vegalite (plot_specs[plot_type]) : md``
)}

function _table1caption(md){return(
md`**Table 1**. Detailed site-by-site results from the BUSTED analysis`
)}

function _table1(Inputs,sites_table){return(
Inputs.table (sites_table[1], {
  rows : 10,
  format: sites_table[0],
  layout: "auto",
  header: sites_table[2]
})
)}

function _tree_id(autoSelect,treeViewOptions,html){return(
autoSelect ({options:treeViewOptions, size : 10, title: html`<b>Tree to view</b>`, placeholder : "Select partition / codon tree to view"})
)}

function _branch_length(Inputs,_,results_json,html){return(
Inputs.select(_.chain (results_json["branch attributes"]["attributes"]).toPairs().filter (d=>d[1]["attribute type"] == "branch length").map (d=>d[0]).value(),{value: "unconstrained", label: html`<b>Branch length </b>`})
)}

function _treeLabels(Inputs,html){return(
Inputs.checkbox(
   ["amino-acids","codons","show internal","show only multiple hits","show only non-synonymous changes","sequence names","align tips","include neighboring codons","show branch labels"],{"value" : ["amino-acids","align tips"], label: html`<b>Tree labels</b>` }
)
)}

function _color_branches(Inputs,tree_color_options,html){return(
Inputs.select(tree_color_options,{value: "Support for selection", label: html`<b>Color branches </b>`})
)}

function _treeDim(text){return(
text({placeholder : "1024 x 800", description: "Tree dimension (height x width in pixels), leave blank to auto-scale", submit: "Resize"})
)}

function _22(tree_id,figure2,Legend,html)
{
  tree_id;
  if (tree_id && figure2.color_scale) {
      return Legend(figure2.color_scale, {
      title: figure2.color_scale_title,
      tickFormat: "f"
    });
  }
  return html``;
}


function _23(figure2,md)
{
  if (figure2) {
      return figure2.show();
  }
  return md`### Select a tree option from the menu above to view`;
}


function _24(md){return(
md`#### Code, data, and libraries`
)}

function _25(html,resolve){return(
html`
      <link rel=stylesheet href='${resolve("phylotree@0.1/phylotree.css")}'>
      <div id="tree_container"></div>`
)}

function _figure2(tree_id,treeLabels,siteIndexPartitionCodon,d3,partition_sizes,display_tree_site,tree_objects,display_tree)
{

    let toDisplay = tree_id.split (" ");
    if (toDisplay.length > 1) {
      let tree_options = {  
          'branch-labels' : treeLabels.indexOf ("show branch labels") >= 0,
          'neighbors' : treeLabels.indexOf ("include neighboring codons") >= 0
      };
      
      if (toDisplay[0] == "Codon") {  
          let codon_index = (+toDisplay[1]);
          let partition_id = siteIndexPartitionCodon [codon_index-1][0]-1;
          codon_index -= d3.sum (partition_sizes.slice (0,partition_id));
          let TT = display_tree_site (partition_id, tree_objects[partition_id], codon_index, tree_options);
          return TT;
      } 
      let pi = (-1) + (+toDisplay[1]);
      let TT = display_tree(pi, tree_objects[pi], tree_options);
      return TT;
    }
    return null;
  /*
    let toDisplay = tree_id.split (" ");
    if (toDisplay.length > 1) {
      if (toDisplay[0] == "Codon") {  
          const codon_index = (+toDisplay[1]);
          let partition_id = siteIndexPartitionCodon [codon_index-1][0]-1;
          let TT = display_tree_site (partition_id, codon_index);
          return TT;
      } 
      let TT = display_tree((-1) + (+toDisplay[1]));
      return TT;
    }
  */
    return null;
}


function _floatFormat(d3){return(
d3.format (".4g")
)}

function _percentageFormat(d3){return(
d3.format (".2p")
)}

function _proportionFormat(d3){return(
d3.format (".5p")
)}

async function _results_json(get_json,params){return(
await get_json (params.get ("url"))
)}

function _sub_fractions(_,results_json){return(
_.map (["Fraction of subs rate at which 2 nucleotides are changed instantly within a single codon", "Fraction of subs rate at which 3 nucleotides are changed instantly within a single codon"], (d)=>results_json["fits"]["Unconstrained model"]["Rate Distributions"][d])
)}

function _get_json(pako,d3,results_file){return(
async (json_source)=>  {
  if (json_source) {
      if (json_source.substr (json_source.length-3) == ".gz") {
        return JSON.parse (pako.inflate(await d3.buffer(json_source), { to: 'string' }));
      }
      return d3.json (json_source);
      try {
        return d3.json (json_source);
      } catch {}
      //results_file.json();
  }
  try {
    return JSON.parse (pako.inflate(await results_file.arrayBuffer(), { to: 'string' }));//results_file.json();
  } catch {}
  return results_file.json();
}
)}

function _fig1data(_,table1,siteTableData)
{
   let in_set = new Set (_.map (table1, (d)=>d.Codon));
   return _.filter (siteTableData[0], (x)=>in_set.has (x.Codon));
}


function _plot_legends(dyn_range_cap,srv_hmm){return(
{
  "Evidence ratio for ω>1 (constrained)" : "Evidence ratios (site level likelihood ratios) for ω>1, comparing the unrestricted model with the model where max(ω) := 1, and all other parameters are kept at their maximum likelihood values. Solid line = user selected significance threshold. <small>Values capped at " + dyn_range_cap + " for readability</small>",
  "Evidence ratio for ω>1 (optimized)" : "Evidence ratios (site level likelihood ratios) for ω>1, comparing the unrestricted model with the optimized constrained model and all other parameters are kept at their maximum likelihood values. Solid line = user selected significance threshold. <small>Values capped at " + dyn_range_cap + " for readability</small>",
  "Synonymous rates" : "Posterior means for synonymous site-level substitution rates (α). " + (srv_hmm ? "The most likely synonymous rate value, based on the Viterbi HMM path inference, is shown in dark red." : "") + "Dots are colored by the evidence ratio (constrained) in favor of positive selection acting on the corresponding site",
  "Support for positive selection" : "Empirical Bayes Factors for ω>1 at a particular branch and site (only tested branches are included).",
  "Error-sink support" : "Empirical Bayes Factors for branch/codon combinations placed in the error-sink category (only tested branches are included).",
  "Support for 2H" : "Evidence ratios for having a non-zero 2-nucleotide substitution rate (δ), comparing the unrestricted model with the model where this rate is 0 at a particular branch/site, and all other parameters are kept at their maximum likelihood values. Values less than one are **not** reported.",
  "Support for 3H" : "Evidence ratios for having a non-zero 3-nucleotide substitution rate (ψ), comparing the unrestricted model with the model where this rate is 0 at a particular branch/site, and all other parameters are kept at their maximum likelihood values. Values less than one are **not** reported.",
  "Support for 2H+3H" : "Evidence ratios for having non-zero 2 or 3-nucleotide substitution rate (δ or ψ), comparing the unrestricted model with the model where these rates are both 0 at a particular branch/site, and all other parameters are kept at their maximum likelihood values. Values less than one are **not** reported.",
  "Site-level LR support" : "Cumulative distribution of the likelihood ratio test for the BUSTED test broken down by the contributions of individual sites"
}
)}

function _plot_options(results_json,srv_rate_classes,bsPositiveSelection,has_error_sink_nt,get_error_sink_rate,mh_rates){return(
[
  ["Evidence ratio for ω>1 (constrained)", (d)=>results_json["Evidence Ratios"]["constrained"]], 
  ["Evidence ratio for ω>1 (optimized)", (d)=>results_json["Evidence Ratios"]["optimized null"]], 
  ["Synonymous rates", (d)=>srv_rate_classes > 0], 
  ["Support for positive selection", (d)=>bsPositiveSelection.length > 0], 
  ["Error-sink support", (d)=>has_error_sink_nt && get_error_sink_rate ("Test")["proportion"] > 0], 
  ["Site-level LR support", (d)=>results_json["Evidence Ratios"]["optimized null"]], 
  ["Support for 2H", (d)=>mh_rates['DH']], 
  ["Support for 3H", (d)=>mh_rates['TH']], 
  ["Support for 2H+3H", (d)=>mh_rates['DH'] && mh_rates['TH']]
]
)}

function _plot_specs(_,fig1data,ERPlot,SRVPlot,srv_hmm,results_json,er_step_size,BSPosteriorPlot,bsPositiveSelection,bsErrorSink,twoHBranchSite,threeHBranchSite,multiHBranchSite,cdsQuant){return(
{
  "Evidence ratio for ω>1 (constrained)" : {
  "width": 800, "height": 150, 
  "vconcat" : _.map (_.range (1, fig1data.length + 1, 70), (d)=> {
      return ERPlot (fig1data, d, 70, "ER (constrained)")
  })},
  "Evidence ratio for ω>1 (optimized)" : {
  "width": 800, "height": 150, 
  "vconcat" : _.map (_.range (1, fig1data.length + 1, 70), (d)=> {
      return ERPlot (fig1data, d, 70, "ER (optimized null)")
  })},
  "Synonymous rates" : {
  "width": 800, "height": 150, 
  "vconcat" : _.map (_.range (1, fig1data.length + 1, 70), (d)=> {
      return SRVPlot (fig1data, d, 70, "SRV posterior mean", srv_hmm ? "SRV viterbi" : null)
  })},
  "Support for positive selection" : {
    //"autosize": {"resize" : true},
    "resolve": {"scale": {"color": "shared"}},
    "vconcat" : _.map (_.range (1, results_json.input["number of sites"], er_step_size()), (d)=> {
        return BSPosteriorPlot (bsPositiveSelection, d, er_step_size())
    })},//.concat (characterPlot (codonComposition (null, true), bsPositiveSelection))},
  "Error-sink support" : {
     //"autosize": {"resize" : true},
    "vconcat" : _.map (_.range (1, results_json.input["number of sites"], er_step_size()), (d)=> {
        return BSPosteriorPlot (bsErrorSink, d, er_step_size())
    })},//.concat (characterPlot (codonComposition (null, false), bsErrorSink))},
  "Support for 2H" : {
     "vconcat" : _.map (_.range (1, results_json.input["number of sites"], er_step_size()), (d)=> {
        return BSPosteriorPlot (twoHBranchSite, d, er_step_size())
   })},
  "Support for 3H" : {
     "vconcat" : _.map (_.range (1, results_json.input["number of sites"], er_step_size()), (d)=> {
        return BSPosteriorPlot (threeHBranchSite, d, er_step_size())
   })},
   "Support for 2H+3H" : {
     "vconcat" : _.map (_.range (1, results_json.input["number of sites"], er_step_size()), (d)=> {
        return BSPosteriorPlot (multiHBranchSite, d, er_step_size())
   })},
   "Site-level LR support" : cdsQuant (fig1data, "LR", "Site LR")
}
)}

function _plot_extras(Inputs){return(
{
    'Support for positive selection' : Inputs.select(['Total subs', 'Syn subs', 'Non-syn subs', 'None'], {'label' : 'Circle size'} ),
    'Error-sink support' : Inputs.select(['Total subs', 'Syn subs', 'Non-syn subs', 'None'], {'label' : 'Circle size'} )
}
)}

function _contributing_sites(_,fig1data,d3)
{
  let site_lr = _.sortBy (_.map (fig1data, (d,i)=>[d["LR"],i]), (d)=>-d[0]);
  const lrs = d3.sum (site_lr, (d)=>d[0]);
  if (lrs > 2) {
      let sites = [];
      let s = site_lr[0][0];
      sites.push (site_lr[0][1]);
      let i = 1;
      while (s < lrs * 0.8) {
        s += site_lr[i][0];  
        sites.push (site_lr[i][1]);
        i ++;
      }
      return sites;
  }
  return null;
  
}


function _siteTableData(_,results_json,siteIndexPartitionCodon,srv_rate_classes,srv_distribution,distMean,srv_hmm,html)
{
  let site_info = [];
  let index = 0;
  _.each (results_json["data partitions"], (pinfo, partition)=> {
      _.each (pinfo["coverage"][0], (ignore, i)=> {
          
              let site_record = {
                  'Partition' : siteIndexPartitionCodon[index][0],
                  'Codon' : siteIndexPartitionCodon[index][1],
              };
              if (results_json["Evidence Ratios"]['optimized null']) {
                  site_record['ER (constrained)'] = results_json["Evidence Ratios"]['constrained'][0][index];
                  site_record['ER (optimized null)'] = results_json["Evidence Ratios"]['optimized null'][0][index];
              };
              site_record['LogL'] = results_json["Site Log Likelihood"]['unconstrained'][0][index];
              if (srv_rate_classes) {
                  let site_srv = [];
                  _.each (srv_distribution, (d,i)=> {
                       site_srv.push ({'value' : d.value, 'weight' : results_json["Synonymous site-posteriors"][i][index]});
                  });
                  site_record['SRV posterior mean'] = distMean (site_srv);
                  if (srv_hmm) {
                      site_record['SRV viterbi'] = srv_distribution[results_json["Viterbi synonymous rate path"][0][index]].value;
                  }
              }
              if (results_json["Evidence Ratios"]['optimized null']) {
                 site_record['LR'] = 2*Math.log (results_json["Evidence Ratios"]['optimized null'][0][index]);
              }
              site_info.push (site_record);
              index++;
          })  
        
      });
    return [site_info, {
      'Partition' : html`<abbr title = "Partition">Part.</abbr>`,
      'Codon' : html`<abbr title = "Site">Codon</abbr>`,
      'ER (constrained)' : html`<abbr title = "Evidence ratio for positive selection (constrained null)">ER (ω>1, constr.)</abbr>`,
      'ER (optimized null)' : html`<abbr title = "Evidence ratio for positive selection (optimized null)">ER (ω>1, optim.)</abbr>`,
      'SRV posterior mean' : html`<abbr title = "Posterior mean of the synonymous rate, α;">E<sub>post</sub>[α]</abbr>`,
      'SRV viterbi' : html`<abbr title = "Most likely rate value for the synonymous rate α (Viterbi path)">α</abbr>`,
      'logL' : html`<abbr title = "Site log-likelihood under the unconstrained model">log(L)</abbr>`,
      'LR' : html`<abbr title = "Site log-likelihood ratio contribution">LR</abbr>`
    }];
}


function _tested_branch_count(d3,_,results_json){return(
d3.median (_.chain (results_json.tested).map ().map((d)=>_.filter (_.map (d), (d)=>d=="test").length).value())
)}

function _get_error_sink_rate(_,results_json){return(
(tag) => {
  let rd = _.get (results_json, ["fits","Unconstrained model","Rate Distributions", tag, "0"]);
  return rd;
}
)}

function _srv_rate_classes(_,results_json){return(
_.size (results_json.fits["Unconstrained model"]["Rate Distributions"]["Synonymous site-to-site rates"])
)}

function _srv_distribution(getRateDistribution){return(
getRateDistribution (["fits","Unconstrained model","Rate Distributions","Synonymous site-to-site rates"], ["rate","proportion"])
)}

function _omega_rate_classes(_,test_omega){return(
_.size (test_omega)
)}

function _partition_sizes(_,results_json)
{
    return _.chain (results_json['data partitions']).map ((d,k)=>(d['coverage'][0].length)).value();
}


function _has_background(_,results_json){return(
_.get (results_json, ["fits","Unconstrained model","Rate Distributions","Background"])
)}

function _srv_hmm(results_json){return(
"Viterbi synonymous rate path" in results_json
)}

function _mh_rates(_,results_json){return(
{
    'DH' : _.get (results_json, ['fits', 'Unconstrained model','Rate Distributions', 'rate at which 2 nucleotides are changed instantly within a single codon']),
    'TH' : _.get (results_json, ['fits', 'Unconstrained model','Rate Distributions', 'rate at which 3 nucleotides are changed instantly within a single codon'])
}
)}

function _table_colors(){return(
{
      'Diversifying' : '#e3243b',
      'Neutral' : '#444',
      'Purifying' : 'green',
      'Invariable' : '#CCC'
    }
)}

function _countBranchesER(test_omega,omega_rate_classes,_,results_json){return(
(er)=> {
    let prior = test_omega[omega_rate_classes-1].weight / (1-test_omega[omega_rate_classes-1].weight);
    let count = [];
    _.each (results_json["branch attributes"], (part_info, part)=> {
        _.each (part_info, (data, branch)=> {
            if (data["Posterior prob omega class"]) {
                let post =  data["Posterior prob omega class"][omega_rate_classes-1];
                post = post / (1-post);
                if (post / prior >= er) {
                    count.push ([part, branch, post/prior]);
                }
            }
        });
    });
     return count;
}
)}

function _test_omega(getRateDistribution){return(
getRateDistribution (["fits","Unconstrained model","Rate Distributions","Test"])
)}

function _distributionTable(_,results_json,getRateDistribution,has_background,srv_rate_classes)
{
  let table = [];
  _.each (["Unconstrained model", "Constrained model"], (m)=> {
      if (!_.get (results_json,["fits",m])) return;
      let record = {'Model' : m};
      record['LogL'] = _.get (results_json,["fits",m,"Log Likelihood"]);
      record['AICc'] = _.get (results_json,["fits",m,"AIC-c"]);
      record['p'] = _.get (results_json,["fits",m,"estimated parameters"]);
      record['dist'] = ["Tested", getRateDistribution (["fits",m,"Rate Distributions","Test"]),"&omega;",m + " ω tested"];
      record['plot'] = ["ω",record['dist'][1]];
      table.push (record);
      if (has_background) {
          record = {'Model' : m};
          record['dist'] = ["Background", getRateDistribution (["fits",m,"Rate Distributions","Background"]),"&omega;",m + " ω background" ];
          record['plot'] = ["ω",record['dist'][1]];
          table.push (record);
      }
      if (srv_rate_classes) {
        record = {'Model' : m};
        record['dist'] = ["Synonymous rates", getRateDistribution (["fits",m,"Rate Distributions","Synonymous site-to-site rates"], ["rate", "proportion"]),"",m + " syn rates" ];
        record['plot'] = ["",record['dist'][1]];
        table.push (record);
      }
  });
  return table;
  //getRateDistribution (["fits","Unconstrained model","Rate Distributions","Test"])
}


function _getRateDistribution(_,results_json,has_error_sink){return(
(keys, tags)=> {
    tags = tags || ["omega", "proportion"];
    const rate_info = _.get (results_json, keys);
    if (rate_info) {
      let clip_first = has_error_sink && tags[0] == 'omega';
      
      return _.sortBy (_.map (clip_first ? _.chain(rate_info).toPairs().filter ((d)=>d[0] != '0').fromPairs().value() : rate_info, (d)=>({
        "value" : d[tags[0]],
        "weight" : d[tags[1]]
      })), (d)=>d.rate);
    }
    return null;
}
)}

function _siteIndexPartitionCodon(_,results_json)
{
    return _.chain (results_json['data partitions']).map ((d,k)=>_.map (d['coverage'][0], (site)=>[+k+1,site+1])).flatten().value();
}


function _sites_table(siteTableData)
{
    return [{}, siteTableData[0], siteTableData[1]];
}


function _posteriorsPerBranchSite(_,results_json,generateNodeLabels,tree_objects,subs_for_pair){return(
(rate_class, prior_odds)=> {
  let results = [];
  let offset = 0;
  _.each (results_json["branch attributes"], (data, partition) => {
      let partition_size = 0;
      let subs = _.get (results_json, ["substitutions",partition]);
      let subs_at_site = {};
      _.each (data, (per_branch, branch)=> {
          if (per_branch ["Posterior prob omega class by site"]) {
            _.each (per_branch ["Posterior prob omega class by site"][rate_class], (p,i)=> {
                if ((i in subs_at_site) == false) {
                     subs_at_site[i] = generateNodeLabels (tree_objects[partition], subs[i]);
                }
                const info = subs_at_site[i][branch];
                
                const sub_count = subs_for_pair (info[2],info[0])
                results.push ({
                    'Key' : branch + "|" + (i + offset + 1), 
                    'Posterior' : p, 
                    'ER' : (p/(1-p))/prior_odds,
                    'from' : info[2],
                    'to' : info[0],
                    'subs' : info[3],
                    'syn_subs' : sub_count[0],
                    'nonsyn_subs' : sub_count[1]
                  },
                );
            });     
            partition_size = per_branch ["Posterior prob omega class by site"][rate_class].length;
          }
      });
      offset += partition_size;
  });
  return results;
}
)}

function _aliview_start(Inputs,sites_table){return(
Inputs.range([1, sites_table[1].length], {label: "Start position", value : 1, step: 1})
)}

function _window_span(Inputs){return(
Inputs.range([10, 50], {label: "Window width", value : 30, step: 1})
)}

function _ali_type(Inputs){return(
Inputs.radio (["Codon", "Amino-acid", "Both"], {label : "Plot type", "value" : "Codon"})
)}

function _color_by(Inputs,ali_color_options){return(
Inputs.radio (['Aminoacid'].concat (ali_color_options), {label : ali_color_options.length ? "Color By" : "", "value" : "Support for EDS"})
)}

function _61(color_by,bsErrorSink,bsPositiveSelection,codonComposition,aliview_start,window_span,_,ali_type,treeNodeOrdering,d3,Plot)
{
  let lookup = null;
  if (color_by == 'Error Annotation') lookup = bsErrorSink;
  if (color_by == 'Support for EDS') lookup = bsPositiveSelection;
  
  const ctest = codonComposition ((site,partition)=>site >= aliview_start-1 && site < aliview_start + window_span-1, 0);
  let letters = _.groupBy (ctest, (d)=>d.Key);
  const aa_cut = (d)=>d.aa.length > 1 ? "#" : d.aa;
  if (lookup) {
      _.each (lookup, (d)=> {
            let c = letters[d.Key];
            if (c) {
                c[0].ER = d.ER;
                c[0].sequence = d.Key.split ("|")[0];
                c[0].site = d.Key.split ("|")[1];
            }
      });
  } else {
      _.each (letters, (d)=>{d[0].ER = aa_cut(d[0]); d[0].sequence = d[0].Key.split ("|")[0];
                d[0].site = d[0].Key.split ("|")[1];});
  }

  
  letters = _.flatten (_.map (letters));
  let sites = _.sortBy (_.uniq (_.map (ctest, (d)=>d.site)), (d)=>+d);
  let text_label = ali_type == "Codon" ? "value" : (ali_type == "Both" ? (d)=>d.value + "/" + aa_cut(d) : aa_cut);
  let text_spacing = ali_type == "Codon" ? 3 : (ali_type == "Both" ? 5 : 2.0);
  const branches = treeNodeOrdering (0, false, 1);
  const label_width = 8*d3.max (branches, (d)=>Math.min (15,d.length));
  return Plot.plot({
      marginLeft : 20 + label_width,
      width : (8*text_spacing) * sites.length + 20 + label_width,
      height : 14 * branches.length + 60,
      padding: 0,
      x : {"domain" : sites, "label" : null, tickRotate : 45},
      y : {"domain" : branches, "label" : null, tickSize: 0,  tickFormat: (d) => (d.length <= 16 ? d : d.substr (0,15) + "...")},
      color : lookup ? {scheme: "BuYlRd", "legend" : true, label: color_by, "type" : "diverging-log", "reverse" : false, symmetric: false, pivot : 1} : {"legend" : true, label: color_by, "type" : "categorical"},
      //y: {tickFormat: Plot.formatMonth("en", "short")},
      marks: [
        Plot.cell(letters, {
          y: "sequence",
          x: "site",
          fill: "ER",
          inset: 0.5,
          opacity : 0.4,
          tip : true
        }),
        
        Plot.text(letters, 
          {y: "sequence", x: "site", "text" : text_label, "fill" : "black", "fontFamily" : "monospace", "fontWeight" : 400})
      ]
    });
}


function _ali_color_options(bsPositiveSelection,bsErrorSink)
{
  let options = [];
  if (bsPositiveSelection.length) options.push ("Support for EDS");
  if (bsErrorSink.length) options.push ("Error Annotation");
  return options;
}


function _codonComposition(_,results_json,generateNodeLabels,tree_objects){return(
(filter, diff_mode)=> {
  let results = [];
  let offset = 0;
  _.each (results_json["substitutions"], (data, partition) => {
      _.each (data, (per_site, site)=> {
            if (filter && ! filter (site, partition)) return;
            let info = generateNodeLabels (tree_objects[partition], per_site);
            
            if (diff_mode == false) {
                 _.each (info, (p,i)=> {
                    if (!p[4]) {
                      results.push ({'Key' : i + "|" + ((+site) + offset + 1), 'value' : p[0], 'aa' : p[1]});
                      //results.push ({'seq' : i,  "site" : ((+site) + offset + 1), 'value' : p[0], 'aa' : p[1]});
                    }
                 });
             } else {
               const root_label = info['root'][0];
               _.each (info, (p,i)=> {
                    let codon_label = _.map (p[0], (c,i)=>c == root_label[i] ? '.' : c).join ("");
                    if (i == 'root') codon_label = p[0];
                    if (!p[4]) {
                        results.push ({'Key' : i + "|" + ((+site) + offset + 1), 'value' : codon_label, 'aa' : p[1]});
                        // results.push ({'seq' : i,  "site" : ((+site) + offset + 1), 'value' : codon_label, 'aa' : p[1]});
                    }
               });
             }
            
      });
    
      offset += _.size (data);
  });
  return results;
}
)}

function _characterPlot(treeNodeOrdering,results_json){return(
(data, data2)=> {
  const branch_order = treeNodeOrdering (0, false, 1);
  let N = results_json.input["number of sequences"];
  let box_size = 10; 
  let font_size = 12;

  //console.log (data2);
  
  let spec = {
      "width": {"step": 2.5*font_size},  "height" : {"step" : font_size},
      "data" : {"values" : 
        data,
      }, 
      "transform" : [
        {"calculate" : "parseInt (split(datum.Key, '|')[1])", "as" : "Codon"},
        {"calculate" : "split(datum.Key, '|')[0]", "as" : "Branch"},
        {"filter": {"param": "character_view", "empty" : true}},
        {
          "lookup": "Key",
          "from": {
            "data": {"values" : data2},
            "key": "Key",
            "fields": ["ER"]
          }
        }
      ],
     
      "encoding": {
        "x": {
          "field": "Codon",
          "type" : "ordinal",
          "scale": {"domain": {"selection": "character_view", "encoding": "x"}},
          "axis": font_size ? {"grid" : false, "titleFontSize" : 14, "title" : "Codon", "labelFontSize" : font_size} : null
        },
        "y": {
          "field": "Branch",
          "scale": {"domain": {"selection": "character_view", "encoding": "y"}},
          "type" : "ordinal",
          "axis": font_size ? {"grid" : false, "titleFontSize" : 14, "title" : "Branch", "labelFontSize" : font_size} : null
        }
      },
      "layer": [
        {
          "mark": {"type": "text", "clip" : true, "fontSize" : font_size, "font" : "monospace", "fontWeight" : "normal", "color" : "#444", "opacity" : 1.0, "tooltip" : true},
          "encoding": {
            "text" : {"field" : "value"},
            "color": {
               "field" : "aa"
               //"field": "ER",
                //"type" : "quantitative",
                //"legend" : {"orient" : "top"},
                //"sort": "ascending",
                //"scale" : {"scheme" : "lightgreyred"}
            }
          }
        }
      ]
  };
  return spec;
}
)}

function _mutliHitER(_,results_json){return(
(key)=> {
  let results = [];
  let offset = 0;
  _.each (results_json["branch attributes"], (data, partition) => {
      let partition_size = 0;
      _.each (data, (per_branch, branch)=> {
          if (per_branch [key]) {
            _.each (per_branch [key], (p,i)=> {
                results.push ({'Key' : branch + "|" + p[0] + offset, 'ER' : p[1]});
            });     
            partition_size = results_json["data partitions"][partition]["coverage"][0].length;
          }
      });
      offset += partition_size;
  });
  return results;
}
)}

function _cdsQuant(){return(
(data, key1, title)=> {
  
  return {
      "config": {
          "mark": {"invalid": null}
      },
      "vconcat" : [
        {
          "width" : 400, "height" : 200,
          "data" : {"values" : data}, 
              "transform": [{
                "sort": [{"field": key1}],
                "window": [{"op": "sum", "field": key1, "as": "CC"}],
                "frame": [null, 0]
              }],
              "layer" : [{
                "mark": {"type" : "area", "opacity" : 0.5, "color" : "grey", "tooltip" : true, "interpolate" : "step"},
                "encoding": {
                  "x": {
                    "field": key1,
                    "type": "quantitative",
                    "axis" : {"title" :  null},
                  },
                  "y": {
                    "field": "CC",
                    "type": "quantitative",
                    "scale" : {"type" : "linear"},
                    "axis" : {"title" : "Cumulative LRT", titleFontSize : 14}
                  }
              }},
              {
                "mark": {"type" : "line", "opacity" : 1.0, "color" : "black",  "interpolate" : "step"},
                "encoding": {
                  "x": {
                    "field": key1,
                   // "sort" : "descending",
                    "type": "quantitative",
                  },
                  "y": {
                    "field": "CC",
                    "type": "quantitative",
                    "scale" : {"type" : "linear"},
                    //"title" : "Cumulative count"
                  },
              }}
      ]
  },
  {
      "width" : 400, "height" : 100,
      "data" : {"values" : data}, 
          
        "mark": {"type" : "bar", "color" : "#ccc", "stroke" : "black", "tooltip" : true},
        "encoding": {
          "x": {
            "field": key1,
            "bin": {"maxbins":200},
            "type": "quantitative",
            "axis" : {"title" :  title ? title : key1, titleFontSize : 14},
          },
          "y": {
            "aggregate": "count",
            "type": "quantitative",
            "scale" : {"type" : "sqrt"},
            "axis" : {"title" :  "Count", titleFontSize : 14},
            //"title" : "Cumulative count"
          }
      
    }
  }]}
}
)}

function _bsErrorSink(has_error_sink_nt,get_error_sink_rate,posteriorsPerBranchSite)
{
  if (has_error_sink_nt) {
    let weight = get_error_sink_rate ("Test")["proportion"];
    return posteriorsPerBranchSite (0, weight / (1-weight));
  }
  return [];
}


function _bsPositiveSelection(test_omega,posteriorsPerBranchSite,has_error_sink)
{
  let w =  test_omega[test_omega.length - 1].weight;
  if (w < 1) {
    return posteriorsPerBranchSite (test_omega.length - 1 + (has_error_sink ? 1 :0),w / (1-w));
  }
  return [];
}


function _twoHBranchSite(mutliHitER){return(
mutliHitER ("Evidence ratio for 2H")
)}

function _threeHBranchSite(mutliHitER){return(
mutliHitER ("Evidence ratio for 3H")
)}

function _multiHBranchSite(mutliHitER){return(
mutliHitER ("Evidence ratio for 2H+3H")
)}

function _treeNodeOrdering(tree_objects,d3,results_json,_){return(
(index, root, only_leaves)=> {
    let order = [];
    if (root) {order.push ('root');}
    const T = tree_objects[index];
    function sort_nodes (asc) {
        T.traverse_and_compute (function (n) {
                var d = 1;
                if (n.children && n.children.length) {
                    d += d3.max (n.children, function (d) { return d["count_depth"];});
                } 

                n["count_depth"] = d;
            });
        T.resortChildren (function (a,b) {
            return (a["count_depth"] - b["count_depth"]) * (asc ? 1 : -1);
        });
    }
    sort_nodes (true);
    T.traverse_and_compute (function (n) {
        if (results_json.tested[index][n.data.name] == "test" && (!only_leaves || _.isUndefined (n.children))) {
          order.push (n.data.name);
        }
    });
    return order;
}
)}

function _distMean(_){return(
(d)=> {
    let m = 0;
    _.each (d, (r)=> {
        m += r['value'] * r['weight'];
    });
    return m;
}
)}

function _distVar(distMean,_){return(
(d)=> {
    let m2 = 0, m = distMean (d);
    _.each (d, (r)=> {
        m2 += r['value']*r['value'] * r['weight'];
    });
    return m2 - m*m;
}
)}

function _has_error_sink(results_json)
{
  const hc = results_json["analysis"]["settings"] && results_json["analysis"]["settings"]["error-sink"];
  if (hc) {
      //if (get_error_sink_rate ("Test")["proportion"] > 0) return true;
      //if (has_background && get_error_sink_rate ("Background")["proportion"] > 0) return true;
      return true;
  }
  return false;
}


function _has_error_sink_nt(has_error_sink,get_error_sink_rate,has_background)
{
  if (has_error_sink) {
      if (get_error_sink_rate ("Test")["proportion"] > 0) return true;
      if (has_background && get_error_sink_rate ("Background")["proportion"] > 0) return true;
      return false;
  }
  return false;
}


function _er_step_size(results_json){return(
()=> {
    let N = results_json.input["number of sequences"];
    if (N < 100) return 70;
    if (N < 200) return 140;
    return 600;
}
)}

function _d3(require){return(
require ("d3")
)}

function _floatFmt(d3){return(
d3.format (".2g")
)}

function _seqNames(){return(
(tree)=> {
    let seq_names = [];
    tree.traverse_and_compute (n=>{
        if (n.children && n.children.length) return;
        seq_names.push (n.data.name);
    });
    return seq_names;
}
)}

function _dyn_range_cap(){return(
10000
)}

function _ERPlot(d3,dyn_range_cap,pv,_){return(
(data, from, step, key)=> {
  let scale = d3.extent (data, (d)=>d[key]); 
  scale[1] = Math.min (dyn_range_cap,Math.max (scale[1], pv));
  scale = d3.nice (scale[0], scale[1], 10);
  return {
      "width": {"step": 12},
      "data" : {"values" : _.map (
        _.filter (data, (d,i)=>i+1 >= from && i< from + step - 1),
      (d)=> {
          let dd = _.clone (d);
          _.each ([key], (f)=> {
            dd[f] = Math.min (dyn_range_cap, dd[f]);
          });
          return dd;
      })}, 
      "encoding": {
        "x": {
          "field": "Codon",
          "type" : "nominal",
          "axis": {"grid" : false, "titleFontSize" : 14, "title" : "Codon"}
        }
      },
      "layer": [
        {
          "mark": {"stroke": "black", "type": "line", "size" : 2, "interpolate" : "step", "color" : "lightgrey", "opacity" : 0.5},
          "encoding": {
            "y": {
               "field": key,
                "type" : "quantitative",
                "scale" : {"type" : "symlog", "domain" : scale},
                "axis" : {"grid" : false}
            }
          }
        },
        {
          "mark": { "stroke": "black", "type": "point", "size" : 100, "filled" : true,  "color" : "lightgrey", "tooltip" : {"contents" : "data"}, "opacity" : 1.},
          "encoding": {
            "y": {
               "field": key,
                "type" : "quantitative",
                
            },
            "color" : {"condition": {"test": "datum['" + key + "'] > " + pv, "value": "firebrick"},
                "value": "lightgrey"
            }
          }
        },
        {
          "mark" : {"opacity": 0.5, "type": "line", "color": "steelblue"},
          "encoding" : { "y": {
                "datum": {"expr": "" + pv},
                "type": "quantitative",
                "scale" : {"domain" : scale}
              },
             
            "size": {"value": 2},
          }
        }
        
      ]
  };
}
)}

function _SRVPlot(_,dyn_range_cap,results_json){return(
(data, from, step, key, key2)=> {
  let spec = {
      "width": {"step": 12},
      "data" : {"values" : _.map (
        _.filter (data, (d,i)=>i+1 >= from && i<= from + step),
      (d)=> {
          let dd = _.clone (d);
          _.each ([key], (f)=> {
            dd[f] = Math.min (dyn_range_cap, dd[f]);
          });
          return dd;
      })}, 
      "encoding": {
        "x": {
          "field": "Codon",
          "type" : "nominal",
          "axis": {"grid" : false, "titleFontSize" : 14, "title" : "Codon"}
        }
      },
      "layer": [
        {
          "mark": {"type": "line", "size" : 2, "color" : "lightgrey", "opacity" : 0.5, "interpolate" : "step"},
          "encoding": {
            "y": {
               "field": key,
                "type" : "quantitative",
            }
          }
        },
        {
          "mark": {"stroke": null, "type": "point", "size" : 100, "filled" : true, "color" : "lightgrey", "tooltip" : {"contents" : "data"}, "opacity" : 1},
          "encoding": {
            "y": {
               "field": key,
                "type" : "quantitative",
                "scale" : {"type" : "symlog"},
                "axis" : {"grid" : false}
            },
            "color" : results_json["Evidence Ratios"]["constrained"] ? {"field" : "ER (constrained)", "type" : "quantitative", "scale" : {"type" : "log", "scheme": "turbo"}, "legend" : {"orient" : "top"}} : null
          }
        }
      ]
  };
  if (key2) {
      spec.layer.push (
        {
          "mark": {"type": "line", "size" : 4, "color" : "lightgrey", "opacity" : 0.5, "interpolate" : "step", "color" : "firebrick"},
          "encoding": {
            "y": {
               "field": key2,
                "type" : "quantitative",
            }
          }
        }
      );
  }
  return spec;
}
)}

function _BSPosteriorPlot(treeNodeOrdering,tested_branch_count,fig1_controls){return(
(data, from, step)=> {
  const branch_order = treeNodeOrdering (0);
  let N = tested_branch_count;
  let box_size = 10; 
  let font_size = 8;

  var size_field = "subs";
  switch (fig1_controls) {
    case "Syn subs":
      size_field = "syn_subs";
      break;
    case "Nonsyn subs":
      size_field = "nonsyn_subs";
      break;
    case "None":
      size_field = null;
      break;
  }
  
  if (N > 50) {
      if (N <= 100) {box_size = 8; font_size = 6;}
      else if (N <= 200) {box_size = 5; font_size = 5;}
      else {box_size = 4; font_size = 0;}
  }
  let spec = {
      "width": {"step": box_size}, "height" : {"step" : box_size},
      "data" : {"values" : 
        data
      }, 
      "transform" : [
        {"calculate" : "parseInt (split(datum.Key, '|')[1])", "as" : "Codon"},
        {"calculate" : "split(datum.Key, '|')[0]", "as" : "Branch"},
        {"filter" : {"field" : "Codon", "range" : [from, from+step-1]}}
      ],
      
      "encoding": {
        "x": {
          "field": "Codon",
          "type" : "nominal",
          "axis": font_size ? {"grid" : false, "titleFontSize" : 14, "title" : "Codon", "labelFontSize" : font_size} : null
        },
        "y": {
          "field": "Branch",
          "scale" : {"domain" : branch_order},
          "type" : "nominal",
          "axis": font_size ? {"grid" : false, "titleFontSize" : 14, "title" : "Branch", "labelFontSize" : font_size} : null
        }
      },
      "layer": [
        {
          /*"params": [{
        "name": "character_view",
        "select": {
          "type": "interval",
          "encodings": ["x","y"],
          "nearest" : "true",
          "mark" : {"stroke" : "#444", "strokeWidth" : 3},
        },
        "value": {"x": _.range (20), "y": branch_order}
      }],*/
          "mark": {"type": "rect", "size" : 2, "color" : "lightgrey", "opacity" : 1.0,  "tooltip": {"content": "data"}},
          "encoding": {
            "color": {
               "field": "ER",
                "type" : "quantitative",
                "legend" : {"orient" : "top"},
                //"domain" : d3.extent (_.map (data, (d)=>d.ER)),
                "sort": "descending",
                "scale" : {"type" : "log", "scheme" : "redyellowblue", "domainMid" : 1}
            }
          }
        }
      ]
  };
  if (size_field) {
      spec.layer.push (
            {
              "mark": {"type": "circle", "size" : 2, "stroke" : "black", "strokeWidth" : 0.5, "color" : null, "opacity" : 1.0},
              "encoding": {
                "color" : {"value" : null},
                "size": {
                   "field": size_field,
                    "type" : "quantitative",
                    "legend" : {"orient" : "top", "title" : "# substitutions"}
                }
              }
            }
        );
  }
  return spec;
}
)}

function _denser_plot(_,dyn_range_cap){return(
(data)=> {
  let columns = [["alpha","α"],["beta","β"],["p-value", "p-value"]];
  return {
      "data" : {"values" : _.map (data,
      (d)=> {
          let dd = _.clone (d);
          _.each (columns, (f)=> {
            dd[f[0]] = Math.min (dyn_range_cap, dd[f[0]]);
          });
          return dd;
      })}, 
      
      "vconcat" : _.map (columns, (cc,i)=> ({
        "width" : 800,
        "height" : 50,
        "mark": {"type": "area", "color" : "lightblue", "stroke" : "black", "interpolate" : "step"},
        "encoding": {
          "x": {
            "field": "codon",
            "type" : "quantitative",
            "axis": {"grid" : false, "titleFontSize" : 14, "title" : i == columns.length -1 ? "Codon" : null}
          },
          "y": {
                 "field": cc[0],
                  "type" : "quantitative",
                  "axis": {"grid" : false, "titleFontSize" : 14, "title" : cc[1]}
              }
        }}))
  };
}
)}

function __(require){return(
require("lodash")
)}

function _tree_objects(_,results_json,phylotree){return(
_.map (results_json.input.trees, (tree,i)=> {
  let T = new phylotree.phylotree (tree);
  T.branch_length_accessor = (n)=>results_json["branch attributes"][i][n.data.name]["Global MG94xREV"];
  return T;
})
)}

function _totalTreeLength(){return(
(tree)=> {
  let L = 0;
  tree.traverse_and_compute ( (n)=> {
     if (tree.branch_length (n)) {
      L += +tree.branch_length (n);
     }
  });
  return L;
}
)}

function _subs_by_branch(_,results_json){return(
(i)=>{
    let counts = {};
    _.each (results_json.substitutions[i], (states, site)=> {
        _.each (states, (state, branch)=> {
          if (branch != "root") {
              if (state != '---') {
                    counts[branch] = 1 + (counts[branch] ? counts[branch] : 0);
              }
          }
        });
    });
    return counts;
}
)}

function _label_color_scale(d3){return(
d3.scaleOrdinal([], d3.schemeCategory10)
)}

function _display_tree(treeDim,_,results_json,branch_length,treeLabels,add_svg_defs,d3,color_branches,test_omega,has_error_sink,get_error_sink_rate,subs_by_branch,add_branch_label,site_support_by_branch,pv){return(
(index, T, options) => {
    let dim = treeDim.length ? _.map (treeDim.split ("x"), (d)=>+d) : null;
      
      T.branch_length_accessor = (n)=>(n.data.name in results_json["branch attributes"][index] ? results_json["branch attributes"][index][n.data.name][branch_length] : 0) || 0;  
      let alignTips = treeLabels.indexOf ("align tips") >= 0;
      var t = T.render({
        height:dim && dim[0], 
        width:dim && dim[1],
        'align-tips' : alignTips,
        'show-scale' : true,
        'is-radial' : false,
        'left-right-spacing': 'fit-to-size', 
        'top-bottom-spacing': 'fit-to-size',
        'node_circle_size' : (n)=>0,
        'internal-names' : treeLabels.indexOf ("show internal") >= 0
       } );
      
      add_svg_defs (t.svg);
  
      function sort_nodes (asc) {
          T.traverse_and_compute (function (n) {
                  var d = 1;
                  if (n.children && n.children.length) {
                      d += d3.max (n.children, function (d) { return d["count_depth"];});
                  } 

                  n["count_depth"] = d;
              });
          T.resortChildren (function (a,b) {
              return (a["count_depth"] - b["count_depth"]) * (asc ? 1 : -1);
          });
        }

        sort_nodes (true);
        t.style_nodes ((e,n) => {
           e.selectAll ("text").style ("font-family", "ui-monospace");
           if (n.children && n.children.length) return; 
           e.selectAll ("title").data ([n.data.name]).join ("title").text ((d)=>d);
        });

        let map2MH = {'Support for 2H' : "Evidence ratio for 2H", 'Support for 3H' : "Evidence ratio for 3H", 'Support for 2H+3H' : "Evidence ratio for 2H+3H"};
        if (color_branches == "Tested") {
          t.style_edges ((e,n) => {
             const is_tested = results_json["tested"][index][n.target.data.name] == "test";
             if (is_tested) {
                e.style ("stroke", "firebrick"); 
             } else {
                e.style ("stroke", null); 
             }
          });
        } else if (color_branches == "Support for Selection" || color_branches == "Error-sink support") {
            let branch_values = {};
            const es = color_branches == "Error-sink support";
            let rate_class = es ? 0 : (test_omega.length - 1 + (has_error_sink ? 1 : 0));
            let prior = es ? get_error_sink_rate ("Test")["proportion"] : test_omega[test_omega.length-1].weight;
            prior = prior / (1-prior);
            T.traverse_and_compute ( (n)=> {
                let posteriors = results_json["branch attributes"][index][n.data.name];
                if (posteriors && posteriors["Posterior prob omega clas"]) {
                    posteriors = posteriors["Posterior prob omega class"][rate_class];
                    branch_values [n.data.name] = posteriors/(1-posteriors)/prior;
                    if (branch_values [n.data.name] < 1) branch_values [n.data.name] = null;
                }
            });
            let color_scale = d3.scaleSequentialLog(d3.extent (_.map (branch_values, (d)=>d)),[0.1,1]);
            t.style_edges ((e,n) => {
             const is_tested = branch_values[n.target.data.name];
             if (is_tested) {
                e.style ("opacity", color_scale(is_tested)).style ("stroke-width", "5").style ("stroke","firebrick"); 
                e.selectAll ("title").data ([is_tested]).join ("title").text ((d)=>d);
             } else {
                e.style ("stroke", null); 
             }
          });
        } else if (color_branches == "Substitutions") {
            let labels = subs_by_branch (index);
            let color_scale = d3.scaleSequential(d3.extent (_.map (labels, d=>d)), d3.interpolateTurbo);
            t.color_scale = color_scale;
            t.color_scale_title = "Min # of nucleotide substitutions";
            
            t.style_edges ((e,n) => {
             const is_tested = labels[n.target.data.name];
             
             if (is_tested) {
                if (options["branch-labels"]) {
                    add_branch_label (e, is_tested, t.font_size, t.svg.selectAll (".phylotree-container"));
                }
                e.style ("stroke", color_scale(is_tested)).style ("stroke-width", "4").style ("opacity",1.0); 
                e.selectAll ("title").data ([is_tested]).join ("title").text ((d)=>d);
             } else {
                e.style ("stroke", null); 
             }
          });
        } else if (map2MH [color_branches]) {
            let branch_values = site_support_by_branch (index, map2MH [color_branches], pv);
            let color_scale = d3.scaleSequentialLog(d3.extent (_.map (branch_values, (d)=>d)),[0.2,1]);
            t.style_edges ((e,n) => {
             const is_tested = branch_values[n.target.data.name];
             if (is_tested) {
                e.style ("opacity", color_scale(is_tested)).style ("stroke-width", "5").style ("stroke","firebrick"); 
                e.selectAll ("title").data ([is_tested]).join ("title").text ((d)=>d);
             } else {
                e.style ("stroke", null); 
             }
          });
        }
        t.placenodes();
        t.update();
        t.nwk = T.getNewick((n)=>results_json["tested"][index][n.data.name] == "test" ? "{Foreground}" : "");
        return t;      
    }
)}

function _site_support_by_branch(_,results_json){return(
(i, key, er)=> {
    let counts = {};
    _.each (results_json["branch attributes"][i], (attribs, branch)=> {
        if (key in attribs) {
          _.each (attribs[key], (d)=> {
            if (d[1] >= er) {
              counts[branch] = 1 + (counts[branch] ? counts[branch] : 0);
            }
          });
        }});
    return counts;
}
)}

function _display_tree_site(treeDim,_,results_json,branch_length,generateNodeLabels,treeLabels,add_svg_defs,display_tree_handle_neighbors,partition_sizes,d3,label_color_scale,color_branches,test_omega,has_error_sink,get_error_sink_rate,add_branch_label){return(
(index,T,s,options) => {
    let dim = treeDim.length ? _.map (treeDim.split ("x"), (d)=>+d) : null;
    T.branch_length_accessor = (n)=>results_json["branch attributes"][index][n.data.name][branch_length] || 0;  
    let node_labels = generateNodeLabels (T, results_json["substitutions"][index][(+s)-1]);

    let labelDomain = new Set();
    let showAA = treeLabels.indexOf ("amino-acids") >= 0;
    let showCodons = treeLabels.indexOf ("codons") >= 0;
    let showSeqNames = treeLabels.indexOf ("sequence names") >= 0;
    let showOnlyMH = treeLabels.indexOf ("show only multiple hits") >= 0;
    let showOnlyNS = treeLabels.indexOf ("show only non-synonymous changes") >= 0;
    let alignTips = treeLabels.indexOf ("align tips") >= 0;
  
    var t = T.render({
      height:dim && dim[0], 
      width:dim && dim[1],
      'show-scale' : true,
      'is-radial' : false,
      'align-tips' : alignTips,
      'left-right-spacing': 'fit-to-size', 
      'top-bottom-spacing': 'fit-to-size',
      'node_circle_size' : (n)=>0,
      'internal-names' : treeLabels.indexOf ("show internal") >= 0
     } );

      add_svg_defs (t.svg);
      
      let extended_labels = display_tree_handle_neighbors (index,s,node_labels,T,options,results_json, partition_sizes[index]);
      t.nodeLabel ((n)=> {
          if (!n._display_me) {
              return "";
          }
          let label = "";
          let has_extended_label = extended_labels[n.data.name] || node_labels[n.data.name];

          n.data.color_on = "";
          
          if (showCodons) {
                label = has_extended_label[0];
                n.data.color_on = node_labels[n.data.name][0];
                if (showAA) label += "/";
          }
        
          if (showAA) {
              label += has_extended_label[1];
              n.data.color_on = node_labels[n.data.name][1];
          }
          
          labelDomain.add ( n.data.color_on);
          if (showSeqNames) label += ":" + n.data.name;
          return label;
      });
      
      function sort_nodes (asc) {
          T.traverse_and_compute (function (n) {
                  var d = 1;
                  if (n.children && n.children.length) {
                      d += d3.max (n.children, function (d) { return d["count_depth"];});
                  } 

                  n["count_depth"] = d;
              });
          T.resortChildren (function (a,b) {
              return (a["count_depth"] - b["count_depth"]) * (asc ? 1 : -1);
          });
        }

       T.traverse_and_compute (function (n) {
            n._display_me = ! (showOnlyMH || showOnlyNS);
         
            if (!n._display_me) {
                if (node_labels[n.data.name]) {
                    if (showOnlyMH && node_labels[n.data.name][3] > 1) n._display_me = true;
                    if (! n._display_me) {
                      if (showOnlyNS) {
                          if (n.parent) {
                              const my_aa = node_labels[n.data.name][1];
                              const parent_aa = node_labels[n.parent.data.name][1];
                              if (my_aa != parent_aa && my_aa != '-' && parent_aa != '-') {
                                  n._display_me = true;
                                  
                                  if (showOnlyMH) n._display_me = node_labels[n.data.name][3] > 1;
                              } else {
                                  n._display_me = false;
                              }
                          }
                      }
                    }
                }
            }
            if (n._display_me && n.parent) {
                n.parent._display_me = true;
            }
            
        },"pre-order");

        sort_nodes (true);
        t.style_nodes ((e,n) => {
           e.selectAll ("text").style ("font-family", "ui-monospace");
           e.selectAll ("text").style ("fill", label_color_scale(n.data.color_on));
           e.selectAll ("title").data ([n.data.name]).join ("title").text ((d)=>d);
        });

        let map2MH = {'Support for 2H' : "Evidence ratio for 2H", 'Support for 3H' : "Evidence ratio for 3H", 'Support for 2H+3H' : "Evidence ratio for 2H+3H"};
    
        if (color_branches == "Tested") {
          t.style_edges ((e,n) => {
             const is_tested = results_json["tested"][index][n.target.data.name] == "test";
             if (is_tested) {
                e.style ("stroke", "firebrick"); 
             } else {
                e.style ("stroke", null); 
             }
          });
        } else if (color_branches == "Support for selection" || color_branches == "Error-sink support") {
            let branch_values = {};
            const es = color_branches == "Error-sink support";
            let rate_class = es ? 0 : (test_omega.length - 1 + (has_error_sink ? 1 : 0));
            let prior = es ? get_error_sink_rate ("Test")["proportion"] : test_omega[test_omega.length-1].weight;
            prior = prior / (1-prior);
            T.traverse_and_compute ( (n)=> {
                let posteriors = results_json["branch attributes"][index][n.data.name];
                if (posteriors && posteriors["Posterior prob omega class by site"]) {
                    posteriors = posteriors["Posterior prob omega class by site"][rate_class][s-1];
                    branch_values [n.data.name] = posteriors/(1-posteriors)/prior;
                    if (branch_values [n.data.name] < 1) branch_values [n.data.name] = null;
                }
            });
            let color_scale = d3.scaleSequentialLog(d3.extent (_.map (branch_values, (d)=>d)),d3.interpolateTurbo);
            t.color_scale = color_scale;
            t.color_scale_title = "Empirical Bayes Factor";
            t.style_edges ((e,n) => {
             const is_tested = branch_values[n.target.data.name];
             if (is_tested) {
                e.style ("stroke", color_scale(is_tested)).style ("stroke-width", "5").style ("opacity",null); 
                e.selectAll ("title").data ([is_tested]).join ("title").text ((d)=>d);
                if (options["branch-labels"]) {
                    add_branch_label (e, is_tested.toFixed(2), t.font_size, t.svg.selectAll (".phylotree-container"));
                }
             } else {
                e.style ("stroke", null); 
             }
          });
        } else if (color_branches == "Substitutions") {
            
            let color_scale = d3.scaleOrdinal([0,1,2,3], d3.schemePuOr[4]);
            t.color_scale = color_scale;
            t.color_scale_title = "Min # of nucleotide substitutions";
            t.style_edges ((e,n) => {
             const is_tested = node_labels[n.target.data.name];
             if (is_tested && is_tested[3]) {
                e.style ("stroke", color_scale(is_tested[3])).style ("stroke-width", "5").style ("opacity","1"); 
                const subs = is_tested[2] + "→" + is_tested[0] + "(" + is_tested[3] + ")";
                e.selectAll ("title").data ([is_tested]).join ("title").text (subs);
                if (options["branch-labels"]) {
                    add_branch_label (e, subs, t.font_size, t.svg.selectAll (".phylotree-container"));
                }
             } else {
                e.style ("stroke", null); 
             }
          });
        } else if (map2MH [color_branches]) {
            let branch_values = {};
            T.traverse_and_compute ( (n)=> {
                let posteriors = results_json["branch attributes"][index][n.data.name];
                if (posteriors && posteriors[map2MH [color_branches]]) {
                    let supp = _.find (posteriors[map2MH [color_branches]], (d)=>d[0] == s-1);
                    if (supp) {
                        branch_values[n.data.name] = supp[1];
                    }
                }
            });
            let color_scale = d3.scaleSequentialLog(d3.extent (_.map (branch_values, (d)=>d)),d3.interpolateTurbo);
            t.color_scale = color_scale;
            t.color_scale_title = "Empirical Bayes Factor";
          
            t.style_edges ((e,n) => {
             const is_tested = branch_values[n.target.data.name];
             if (is_tested) {
                e.style ("stroke", color_scale(is_tested)).style ("stroke-width", "5").style ("opacity","1"); 
                e.selectAll ("title").data ([is_tested]).join ("title").text ((d)=>d);
                if (options["branch-labels"]) {
                    add_branch_label (e, is_tested.toFixed(2), t.font_size, t.svg.selectAll (".phylotree-container"));
                }
             } else {
                e.style ("stroke", null); 
             }
          });
        }
        t.placenodes();
        t.update();
        label_color_scale.domain (labelDomain);
        return t;      
    }
)}

function _treeViewOptions(_,tree_objects,results_json)
{
  let opts = _.map (_.range (1,tree_objects.length+1), (d)=>"Partition " + d);
  if (results_json.substitutions) {
    opts = opts.concat(_.map (_.range (1,results_json.input["number of sites"]+1), (d)=>"Codon " + d));
  }
  return opts;
}


function _tree_color_options(results_json,mh_rates,has_error_sink)
{
  let options = ["Tested"];
  if (results_json.substitutions) {
    options.push ("Support for selection");
    options.push ("Substitutions");
  }
  if (mh_rates["DH"]) options.push ("Support for 2H");
  if (mh_rates["TH"]) options.push ("Support for 3H");
  if (mh_rates["DH"] && mh_rates["TH"]) options.push ("Support for 2H+3H");
  if (has_error_sink) options.push ("Error-sink support");
  return options;
}


function _phylotree(require){return(
require ("phylotree")
)}

function _vegalite(require){return(
require ("vega-embed")
)}

function _params(URLSearchParams,location){return(
new URLSearchParams(location.search)
)}

function _pako(require){return(
require('pako@2.1.0/dist/pako.min.js')
)}

function _108(bustedStyle){return(
bustedStyle
)}

function _simpleIcons(html){return(
html`<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/simple-line-icons/2.4.1/css/simple-line-icons.css">`
)}

export default function define(runtime, observer) {
  const main = runtime.module();
  main.variable(observer()).define(["md"], _1);
  main.variable(observer("viewof results_file")).define("viewof results_file", ["params","localFileInput"], _results_file);
  main.variable(observer("results_file")).define("results_file", ["Generators", "viewof results_file"], (G, _) => G.input(_));
  main.variable(observer("intro")).define("intro", ["md","results_json","floatFormat","srv_rate_classes","srv_hmm","_","mh_rates","contributing_sites","has_error_sink"], _intro);
  main.variable(observer()).define(["md","has_error_sink_nt","proportionFormat","get_error_sink_rate","has_background"], _4);
  main.variable(observer("citation")).define("citation", ["md","results_json"], _citation);
  main.variable(observer("viewof pv")).define("viewof pv", ["Inputs","html"], _pv);
  main.variable(observer("pv")).define("pv", ["Generators", "viewof pv"], (G, _) => G.input(_));
  main.variable(observer("summary_table")).define("summary_table", ["html","results_json","tested_branch_count","omega_rate_classes","srv_rate_classes","srv_hmm","floatFmt","_","pv","mh_rates","bsPositiveSelection","contributing_sites","sub_fractions","percentageFormat"], _summary_table);
  main.variable(observer("alignmentHeader")).define("alignmentHeader", ["md"], _alignmentHeader);
  main.variable(observer("viewof rate_table")).define("viewof rate_table", ["Inputs","distributionTable","html","d3","_","floatFormat","proportionFormat","distMean","distVar","renderDiscreteDistribution","srv_rate_classes","has_background"], _rate_table);
  main.variable(observer("rate_table")).define("rate_table", ["Generators", "viewof rate_table"], (G, _) => G.input(_));
  main.variable(observer("distComparisonPlot")).define("distComparisonPlot", ["rate_table","renderTwoDiscreteDistributions","md"], _distComparisonPlot);
  main.variable(observer("viewof plot_type")).define("viewof plot_type", ["Inputs","_","plot_options","results_json","html"], _plot_type);
  main.variable(observer("plot_type")).define("plot_type", ["Generators", "viewof plot_type"], (G, _) => G.input(_));
  main.variable(observer("viewof fig1_controls")).define("viewof fig1_controls", ["plot_extras","plot_type","Inputs"], _fig1_controls);
  main.variable(observer("fig1_controls")).define("fig1_controls", ["Generators", "viewof fig1_controls"], (G, _) => G.input(_));
  main.variable(observer("fig1caption")).define("fig1caption", ["md","plot_type","plot_legends"], _fig1caption);
  main.variable(observer("figure1")).define("figure1", ["plot_type","vegalite","plot_specs","md"], _figure1);
  main.variable(observer("table1caption")).define("table1caption", ["md"], _table1caption);
  main.variable(observer("viewof table1")).define("viewof table1", ["Inputs","sites_table"], _table1);
  main.variable(observer("table1")).define("table1", ["Generators", "viewof table1"], (G, _) => G.input(_));
  main.variable(observer("viewof tree_id")).define("viewof tree_id", ["autoSelect","treeViewOptions","html"], _tree_id);
  main.variable(observer("tree_id")).define("tree_id", ["Generators", "viewof tree_id"], (G, _) => G.input(_));
  main.variable(observer("viewof branch_length")).define("viewof branch_length", ["Inputs","_","results_json","html"], _branch_length);
  main.variable(observer("branch_length")).define("branch_length", ["Generators", "viewof branch_length"], (G, _) => G.input(_));
  main.variable(observer("viewof treeLabels")).define("viewof treeLabels", ["Inputs","html"], _treeLabels);
  main.variable(observer("treeLabels")).define("treeLabels", ["Generators", "viewof treeLabels"], (G, _) => G.input(_));
  main.variable(observer("viewof color_branches")).define("viewof color_branches", ["Inputs","tree_color_options","html"], _color_branches);
  main.variable(observer("color_branches")).define("color_branches", ["Generators", "viewof color_branches"], (G, _) => G.input(_));
  main.variable(observer("viewof treeDim")).define("viewof treeDim", ["text"], _treeDim);
  main.variable(observer("treeDim")).define("treeDim", ["Generators", "viewof treeDim"], (G, _) => G.input(_));
  main.variable(observer()).define(["tree_id","figure2","Legend","html"], _22);
  main.variable(observer()).define(["figure2","md"], _23);
  main.variable(observer()).define(["md"], _24);
  main.variable(observer()).define(["html","resolve"], _25);
  main.variable(observer("figure2")).define("figure2", ["tree_id","treeLabels","siteIndexPartitionCodon","d3","partition_sizes","display_tree_site","tree_objects","display_tree"], _figure2);
  main.variable(observer("floatFormat")).define("floatFormat", ["d3"], _floatFormat);
  main.variable(observer("percentageFormat")).define("percentageFormat", ["d3"], _percentageFormat);
  main.variable(observer("proportionFormat")).define("proportionFormat", ["d3"], _proportionFormat);
  main.variable(observer("results_json")).define("results_json", ["get_json","params"], _results_json);
  main.variable(observer("sub_fractions")).define("sub_fractions", ["_","results_json"], _sub_fractions);
  main.variable(observer("get_json")).define("get_json", ["pako","d3","results_file"], _get_json);
  main.variable(observer("fig1data")).define("fig1data", ["_","table1","siteTableData"], _fig1data);
  main.variable(observer("plot_legends")).define("plot_legends", ["dyn_range_cap","srv_hmm"], _plot_legends);
  main.variable(observer("plot_options")).define("plot_options", ["results_json","srv_rate_classes","bsPositiveSelection","has_error_sink_nt","get_error_sink_rate","mh_rates"], _plot_options);
  main.variable(observer("plot_specs")).define("plot_specs", ["_","fig1data","ERPlot","SRVPlot","srv_hmm","results_json","er_step_size","BSPosteriorPlot","bsPositiveSelection","bsErrorSink","twoHBranchSite","threeHBranchSite","multiHBranchSite","cdsQuant"], _plot_specs);
  main.variable(observer("plot_extras")).define("plot_extras", ["Inputs"], _plot_extras);
  main.variable(observer("contributing_sites")).define("contributing_sites", ["_","fig1data","d3"], _contributing_sites);
  main.variable(observer("siteTableData")).define("siteTableData", ["_","results_json","siteIndexPartitionCodon","srv_rate_classes","srv_distribution","distMean","srv_hmm","html"], _siteTableData);
  main.variable(observer("tested_branch_count")).define("tested_branch_count", ["d3","_","results_json"], _tested_branch_count);
  main.variable(observer("get_error_sink_rate")).define("get_error_sink_rate", ["_","results_json"], _get_error_sink_rate);
  main.variable(observer("srv_rate_classes")).define("srv_rate_classes", ["_","results_json"], _srv_rate_classes);
  main.variable(observer("srv_distribution")).define("srv_distribution", ["getRateDistribution"], _srv_distribution);
  main.variable(observer("omega_rate_classes")).define("omega_rate_classes", ["_","test_omega"], _omega_rate_classes);
  main.variable(observer("partition_sizes")).define("partition_sizes", ["_","results_json"], _partition_sizes);
  main.variable(observer("has_background")).define("has_background", ["_","results_json"], _has_background);
  main.variable(observer("srv_hmm")).define("srv_hmm", ["results_json"], _srv_hmm);
  main.variable(observer("mh_rates")).define("mh_rates", ["_","results_json"], _mh_rates);
  main.variable(observer("table_colors")).define("table_colors", _table_colors);
  main.variable(observer("countBranchesER")).define("countBranchesER", ["test_omega","omega_rate_classes","_","results_json"], _countBranchesER);
  main.variable(observer("test_omega")).define("test_omega", ["getRateDistribution"], _test_omega);
  main.variable(observer("distributionTable")).define("distributionTable", ["_","results_json","getRateDistribution","has_background","srv_rate_classes"], _distributionTable);
  main.variable(observer("getRateDistribution")).define("getRateDistribution", ["_","results_json","has_error_sink"], _getRateDistribution);
  main.variable(observer("siteIndexPartitionCodon")).define("siteIndexPartitionCodon", ["_","results_json"], _siteIndexPartitionCodon);
  main.variable(observer("sites_table")).define("sites_table", ["siteTableData"], _sites_table);
  main.variable(observer("posteriorsPerBranchSite")).define("posteriorsPerBranchSite", ["_","results_json","generateNodeLabels","tree_objects","subs_for_pair"], _posteriorsPerBranchSite);
  main.variable(observer("viewof aliview_start")).define("viewof aliview_start", ["Inputs","sites_table"], _aliview_start);
  main.variable(observer("aliview_start")).define("aliview_start", ["Generators", "viewof aliview_start"], (G, _) => G.input(_));
  main.variable(observer("viewof window_span")).define("viewof window_span", ["Inputs"], _window_span);
  main.variable(observer("window_span")).define("window_span", ["Generators", "viewof window_span"], (G, _) => G.input(_));
  main.variable(observer("viewof ali_type")).define("viewof ali_type", ["Inputs"], _ali_type);
  main.variable(observer("ali_type")).define("ali_type", ["Generators", "viewof ali_type"], (G, _) => G.input(_));
  main.variable(observer("viewof color_by")).define("viewof color_by", ["Inputs","ali_color_options"], _color_by);
  main.variable(observer("color_by")).define("color_by", ["Generators", "viewof color_by"], (G, _) => G.input(_));
  main.variable(observer()).define(["color_by","bsErrorSink","bsPositiveSelection","codonComposition","aliview_start","window_span","_","ali_type","treeNodeOrdering","d3","Plot"], _61);
  main.variable(observer("ali_color_options")).define("ali_color_options", ["bsPositiveSelection","bsErrorSink"], _ali_color_options);
  main.variable(observer("codonComposition")).define("codonComposition", ["_","results_json","generateNodeLabels","tree_objects"], _codonComposition);
  main.variable(observer("characterPlot")).define("characterPlot", ["treeNodeOrdering","results_json"], _characterPlot);
  main.variable(observer("mutliHitER")).define("mutliHitER", ["_","results_json"], _mutliHitER);
  main.variable(observer("cdsQuant")).define("cdsQuant", _cdsQuant);
  main.variable(observer("bsErrorSink")).define("bsErrorSink", ["has_error_sink_nt","get_error_sink_rate","posteriorsPerBranchSite"], _bsErrorSink);
  main.variable(observer("bsPositiveSelection")).define("bsPositiveSelection", ["test_omega","posteriorsPerBranchSite","has_error_sink"], _bsPositiveSelection);
  main.variable(observer("twoHBranchSite")).define("twoHBranchSite", ["mutliHitER"], _twoHBranchSite);
  main.variable(observer("threeHBranchSite")).define("threeHBranchSite", ["mutliHitER"], _threeHBranchSite);
  main.variable(observer("multiHBranchSite")).define("multiHBranchSite", ["mutliHitER"], _multiHBranchSite);
  main.variable(observer("treeNodeOrdering")).define("treeNodeOrdering", ["tree_objects","d3","results_json","_"], _treeNodeOrdering);
  main.variable(observer("distMean")).define("distMean", ["_"], _distMean);
  main.variable(observer("distVar")).define("distVar", ["distMean","_"], _distVar);
  main.variable(observer("has_error_sink")).define("has_error_sink", ["results_json"], _has_error_sink);
  main.variable(observer("has_error_sink_nt")).define("has_error_sink_nt", ["has_error_sink","get_error_sink_rate","has_background"], _has_error_sink_nt);
  main.variable(observer("er_step_size")).define("er_step_size", ["results_json"], _er_step_size);
  main.variable(observer("d3")).define("d3", ["require"], _d3);
  main.variable(observer("floatFmt")).define("floatFmt", ["d3"], _floatFmt);
  main.variable(observer("seqNames")).define("seqNames", _seqNames);
  main.variable(observer("dyn_range_cap")).define("dyn_range_cap", _dyn_range_cap);
  main.variable(observer("ERPlot")).define("ERPlot", ["d3","dyn_range_cap","pv","_"], _ERPlot);
  main.variable(observer("SRVPlot")).define("SRVPlot", ["_","dyn_range_cap","results_json"], _SRVPlot);
  main.variable(observer("BSPosteriorPlot")).define("BSPosteriorPlot", ["treeNodeOrdering","tested_branch_count","fig1_controls"], _BSPosteriorPlot);
  main.variable(observer("denser_plot")).define("denser_plot", ["_","dyn_range_cap"], _denser_plot);
  main.variable(observer("_")).define("_", ["require"], __);
  main.variable(observer("tree_objects")).define("tree_objects", ["_","results_json","phylotree"], _tree_objects);
  main.variable(observer("totalTreeLength")).define("totalTreeLength", _totalTreeLength);
  main.variable(observer("subs_by_branch")).define("subs_by_branch", ["_","results_json"], _subs_by_branch);
  main.variable(observer("label_color_scale")).define("label_color_scale", ["d3"], _label_color_scale);
  main.variable(observer("display_tree")).define("display_tree", ["treeDim","_","results_json","branch_length","treeLabels","add_svg_defs","d3","color_branches","test_omega","has_error_sink","get_error_sink_rate","subs_by_branch","add_branch_label","site_support_by_branch","pv"], _display_tree);
  main.variable(observer("site_support_by_branch")).define("site_support_by_branch", ["_","results_json"], _site_support_by_branch);
  main.variable(observer("display_tree_site")).define("display_tree_site", ["treeDim","_","results_json","branch_length","generateNodeLabels","treeLabels","add_svg_defs","display_tree_handle_neighbors","partition_sizes","d3","label_color_scale","color_branches","test_omega","has_error_sink","get_error_sink_rate","add_branch_label"], _display_tree_site);
  main.variable(observer("treeViewOptions")).define("treeViewOptions", ["_","tree_objects","results_json"], _treeViewOptions);
  main.variable(observer("tree_color_options")).define("tree_color_options", ["results_json","mh_rates","has_error_sink"], _tree_color_options);
  main.variable(observer("phylotree")).define("phylotree", ["require"], _phylotree);
  main.variable(observer("vegalite")).define("vegalite", ["require"], _vegalite);
  const child1 = runtime.module(define1);
  main.import("select", child1);
  main.import("text", child1);
  main.import("input", child1);
  main.import("autoSelect", child1);
  const child2 = runtime.module(define2);
  main.import("add_svg_defs", child2);
  main.import("add_branch_label", child2);
  main.import("subs_for_pair", child2);
  main.import("display_tree_handle_neighbors", child2);
  main.variable(observer("params")).define("params", ["URLSearchParams","location"], _params);
  const child3 = runtime.module(define3);
  main.import("legend", child3);
  const child4 = runtime.module(define4);
  main.import("localFileInput", child4);
  const child5 = runtime.module(define5);
  main.import("renderDiscreteDistribution", child5);
  main.import("renderNDiscreteDistributions", child5);
  main.import("renderTwoDiscreteDistributions", child5);
  const child6 = runtime.module(define2);
  main.import("generateNodeLabels", child6);
  const child7 = runtime.module(define6);
  main.import("translate_ambiguous_codon", child7);
  const child8 = runtime.module(define3);
  main.import("Legend", child8);
  main.import("Swatches", child8);
  main.variable(observer("pako")).define("pako", ["require"], _pako);
  main.variable(observer()).define(["bustedStyle"], _108);
  const child9 = runtime.module(define2);
  main.import("bustedStyle", child9);
  main.variable(observer("simpleIcons")).define("simpleIcons", ["html"], _simpleIcons);
  return main;
}
